export enum DashboardMyFavouritesWidgetBlock {
  Root = 'DashboardMyFavouritesWidget',
}
